import React, { useState, useEffect } from "react";
import classNames from 'classnames/bind';

const Toggle = ({ value, onChange, size, on, off, className, inside = false }) => {

  const [toggle, setToggle] = useState(value);

  const clickHandler = () => {
    const toggleValue = !toggle;
    setToggle(toggleValue);
    onChange(toggleValue);
  }

  const cxButton = classNames({
    btn: true,
    'btn-toggle': true,
    'btn-lg': size && size == 'lg',
    'btn-sm': size && size == 'sm',
    'btn-xs': size && size == 'xs',
    active: toggle,
    'with-labels': !inside && (on || off),
    'with-included-labels': inside,
    className
  });

  useEffect(() => {
    setToggle(value)
  }, [value])

  return (<button onClick={clickHandler}
          className={cxButton}
          aria-pressed={toggle}
          data-toggle="button"
          data-on={on || ''}
          data-off={off || ''}
          autoComplete="off">
            <span className="handle"></span>
        </button>);
}

export default Toggle;

